var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"container"},[_vm._v(" Setting token: "+_vm._s(_vm.token)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }